import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import {
   createInterpolatedTranslationKey,
   createSingleInterpolatedTranslationKey,
   TranslatableText,
} from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../translations';

export const getDoctorsChipFilterLabel = (
   practitionerIds: Array<string>,
   healthcareProviderDoctors: DoctorSimple[]
): TranslatableText => {
   if (practitionerIds.length === 1) {
      const foundPractitioner = healthcareProviderDoctors.find(
         ({ practitionerId }) => practitionerId.toString() === practitionerIds.at(0)
      );

      if (!foundPractitioner) {
         return appointmentsTranslationKeys.filters.unknownSpecialist;
      }

      return createInterpolatedTranslationKey(appointmentsTranslationKeys.filters.specialist, {
         firstName: foundPractitioner.firstName,
         lastName: foundPractitioner.lastName,
      });
   }

   if (healthcareProviderDoctors.length === practitionerIds.length) {
      return appointmentsTranslationKeys.filters.allSpecialists;
   }

   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.filters.specialistsCount,
      'count',
      practitionerIds.length
   );
};
